import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api, apiError } from '../lib/api';
import { MapEmbed } from '../components/MapPicker';

const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

// Inline SVG brand icons (no external dependency)
const SocialIcons = {
  Facebook: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.9h2.54V9.85c0-2.52 1.5-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.9h2.78l-.44 2.9h-2.34V22c4.78-.79 8.43-4.94 8.43-9.94z"/>
    </svg>
  ),
  Instagram: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.21 8.8 2.2 12 2.2zm0 1.8c-3.15 0-3.5.01-4.74.07-1.14.05-1.76.24-2.17.4-.55.21-.94.47-1.35.88-.41.41-.67.8-.88 1.35-.16.41-.35 1.03-.4 2.17C2.4 8.5 2.4 8.85 2.4 12s.01 3.5.07 4.74c.05 1.14.24 1.76.4 2.17.21.55.47.94.88 1.35.41.41.8.67 1.35.88.41.16 1.03.35 2.17.4 1.24.06 1.59.07 4.74.07s3.5-.01 4.74-.07c1.14-.05 1.76-.24 2.17-.4.55-.21.94-.47 1.35-.88.41-.41.67-.8.88-1.35.16-.41.35-1.03.4-2.17.06-1.24.07-1.59.07-4.74s-.01-3.5-.07-4.74c-.05-1.14-.24-1.76-.4-2.17a3.6 3.6 0 0 0-.88-1.35 3.6 3.6 0 0 0-1.35-.88c-.41-.16-1.03-.35-2.17-.4C15.5 4.01 15.15 4 12 4zm0 3.06a4.94 4.94 0 1 1 0 9.88 4.94 4.94 0 0 1 0-9.88zm0 1.8a3.14 3.14 0 1 0 0 6.28 3.14 3.14 0 0 0 0-6.28zm5.15-2.85a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3z"/>
    </svg>
  ),
  Twitter: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.22-6.82-5.97 6.82H1.66l7.73-8.84L1.25 2.25h6.83l4.72 6.24 5.44-6.24zm-1.16 17.52h1.83L7.01 4.13H5.05l12.03 15.64z"/>
    </svg>
  ),
  LinkedIn: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z"/>
    </svg>
  ),
  YouTube: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.51A3.02 3.02 0 0 0 .5 6.2C0 8.08 0 12 0 12s0 3.92.5 5.8a3.02 3.02 0 0 0 2.12 2.14c1.88.51 9.38.51 9.38.51s7.5 0 9.38-.51a3.02 3.02 0 0 0 2.12-2.14C24 15.92 24 12 24 12s0-3.92-.5-5.8zM9.55 15.57V8.43L15.82 12l-6.27 3.57z"/>
    </svg>
  ),
  WhatsApp: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.03 1-1.03 2.45 0 1.45 1.05 2.85 1.2 3.05.15.2 2.07 3.17 5.02 4.44.7.3 1.25.48 1.68.62.7.22 1.35.19 1.86.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 2.1a9.9 9.9 0 0 0-8.45 15.13L2.05 22l4.9-1.53a9.9 9.9 0 0 0 5.1 1.41h.01a9.9 9.9 0 0 0 0-19.78zm0 18.06h-.01c-1.6 0-3.18-.43-4.55-1.25l-.33-.19-3.4 1.06 1.06-3.32-.22-.34a8.24 8.24 0 0 1-1.26-4.4 8.24 8.24 0 0 1 8.24-8.24 8.24 8.24 0 0 1 8.24 8.24 8.24 8.24 0 0 1-7.77 8.24z"/>
    </svg>
  ),
  Phone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  Globe: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10"/>
      <line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  Share: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="18" cy="5" r="3"/>
      <circle cx="6" cy="12" r="3"/>
      <circle cx="18" cy="19" r="3"/>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
    </svg>
  ),
  Mail: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="M22 6l-10 7L2 6"/>
    </svg>
  ),
  MapPin: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  ),
};

// Styles for social icons and contact buttons
const businessDetailStyle = `
  .bd-social-row {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid #eef2ff;
  }
  .bd-social-btn {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-decoration: none;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
    position: relative;
    overflow: hidden;
  }
  .bd-social-btn svg {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 1;
  }
  .bd-social-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.35), rgba(255,255,255,0));
    opacity: 0;
    transition: opacity 0.28s ease;
  }
  .bd-social-btn:hover {
    transform: translateY(-3px) scale(1.06);
    box-shadow: 0 10px 22px -6px rgba(15, 23, 42, 0.35);
  }
  .bd-social-btn:hover::before { opacity: 1; }

  .bd-social-fb { background: linear-gradient(135deg, #1877F2, #0c5fcc); }
  .bd-social-ig { background: linear-gradient(135deg, #F58529, #DD2A7B, #8134AF); }
  .bd-social-x  { background: linear-gradient(135deg, #1a1a1a, #3a3a3a); }
  .bd-social-in { background: linear-gradient(135deg, #0A66C2, #004182); }
  .bd-social-yt { background: linear-gradient(135deg, #FF0000, #c40000); }

  /* Contact action buttons */
  .bd-actions-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.55rem;
  }
  .bd-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    padding: 0.62rem 1.15rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.9rem;
    border: none;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    line-height: 1;
  }
  .bd-action-btn svg {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
  }
  .bd-action-btn:hover {
    transform: translateY(-2px);
  }
  .bd-action-call {
    background: linear-gradient(135deg, #4338CA, #6366F1);
    color: #fff;
    box-shadow: 0 6px 16px -6px rgba(67, 56, 202, 0.5);
  }
  .bd-action-call:hover {
    box-shadow: 0 12px 26px -8px rgba(67, 56, 202, 0.65);
    color: #fff;
  }
  .bd-action-wa {
    background: linear-gradient(135deg, #25D366, #128C7E);
    color: #fff;
    box-shadow: 0 6px 16px -6px rgba(18, 140, 126, 0.5);
  }
  .bd-action-wa:hover {
    box-shadow: 0 12px 26px -8px rgba(18, 140, 126, 0.65);
    color: #fff;
  }
  .bd-action-outline {
    background: #fff;
    color: #4338CA;
    border: 1.5px solid #C7D2FE;
    box-shadow: 0 2px 8px rgba(67, 56, 202, 0.06);
  }
  .bd-action-outline:hover {
    background: #F5F3FF;
    border-color: #4338CA;
    color: #4338CA;
    box-shadow: 0 8px 20px -6px rgba(67, 56, 202, 0.25);
  }

  /* Mini contact details list with icons */
  .bd-contact-item {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f1f5f9;
    font-size: 0.875rem;
    color: #334155;
    word-break: break-word;
  }
  .bd-contact-item:last-child { border-bottom: none; }
  .bd-contact-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: linear-gradient(135deg, #EEF2FF, #E0E7FF);
    color: #4338CA;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .bd-contact-icon svg { width: 15px; height: 15px; }
  .bd-contact-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #94a3b8;
    display: block;
    margin-bottom: 1px;
  }
  .bd-contact-value {
    color: #1a202c;
    font-weight: 500;
    line-height: 1.35;
    text-decoration: none;
  }
  .bd-contact-value:hover { color: #4338CA; }
`;

export default function BusinessDetail() {
  const { slug } = useParams();
  const [biz, setBiz] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [enqOpen, setEnqOpen] = useState(false);
  const [form, setForm] = useState({ customer_name:'', customer_email:'', customer_phone:'', message:'' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [enqErr, setEnqErr] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true); setErr('');
      try {
        const { data } = await api.get(`/businesses/${slug}`);
        setBiz(data.business);
      } catch (e) { setErr(apiError(e, 'Not found')); }
      finally { setLoading(false); }
    })();
  }, [slug]);

  const submitEnq = async (e) => {
    e.preventDefault();
    setSending(true); setEnqErr('');
    try {
      await api.post('/enquiries', { business_id: biz.id, source: 'online_form', ...form });
      setSent(true);
    } catch (e) { setEnqErr(apiError(e, 'Could not send enquiry. Please try again.')); }
    finally { setSending(false); }
  };

  const share = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) await navigator.share({ title: biz.name, text: `Check out ${biz.name}`, url });
      else { await navigator.clipboard.writeText(url); alert('Link copied to clipboard'); }
    } catch {}
  };

  if (loading) return <div className="container text-center py-5"><span className="ap-loader" /></div>;
  if (err || !biz) return <div className="container my-5"><div className="alert alert-danger" data-testid="detail-error">{err}</div></div>;

  const waNumber = (biz.whatsapp || '').replace(/[^0-9]/g,'');
  const waHref = waNumber ? `https://wa.me/${waNumber}?text=${encodeURIComponent('Hi ' + biz.name + ', I found you on Business Pride India.')}` : null;

  // Build social links array (only existing ones)
  const socialLinks = [
    biz.facebook_url  && { name: 'Facebook',  href: biz.facebook_url,  cls: 'bd-social-fb', Icon: SocialIcons.Facebook,  testid: 'detail-facebook-btn' },
    biz.instagram_url && { name: 'Instagram', href: biz.instagram_url, cls: 'bd-social-ig', Icon: SocialIcons.Instagram, testid: 'detail-instagram-btn' },
    biz.twitter_url   && { name: 'X',         href: biz.twitter_url,   cls: 'bd-social-x',  Icon: SocialIcons.Twitter,   testid: 'detail-twitter-btn' },
    biz.linkedin_url  && { name: 'LinkedIn',  href: biz.linkedin_url,  cls: 'bd-social-in', Icon: SocialIcons.LinkedIn,  testid: 'detail-linkedin-btn' },
    biz.youtube_url   && { name: 'YouTube',   href: biz.youtube_url,   cls: 'bd-social-yt', Icon: SocialIcons.YouTube,   testid: 'detail-youtube-btn' },
  ].filter(Boolean);

  return (
    <div className="container my-4" data-testid="business-detail">
      <style>{businessDetailStyle}</style>

      <div className="mb-3 small text-muted-2">
        <Link to="/" className="no-underline">Home</Link> ›{' '}
        <Link to={`/search?city=${biz.city_slug}`} className="no-underline">{biz.city_name}</Link> ›{' '}
        <Link to={`/search?category=${biz.category_slug}`} className="no-underline">{biz.category_name}</Link> ›{' '}
        <span>{biz.name}</span>
      </div>

      <div className="detail-hero">
        {biz.cover_url && <img src={biz.cover_url} alt={biz.name} />}
        <div className="overlay">
          <div>
            {biz.is_premium ? <span className="badge-premium" style={{ position:'relative', top:0, right:0 }} data-testid="premium-badge">Premium</span> : null}
            <h1 className="mt-2" style={{ color:'#fff' }}>{biz.name}</h1>
            <div className="opacity-75">{biz.tagline}</div>
            <div className="small opacity-75">{biz.category_name} · {biz.city_name}</div>
          </div>
        </div>
      </div>

      <div className="row g-4 mt-1">
        <div className="col-lg-8">
          <div className="ap-card mb-3">
            <div className="bd-actions-row">
              {biz.phone && (
                <a href={`tel:${biz.phone}`} className="bd-action-btn bd-action-call" data-testid="detail-call-btn">
                  <SocialIcons.Phone />
                  Call 
                </a>
              )}
              {waHref && (
                <a className="bd-action-btn bd-action-wa" href={waHref} target="_blank" rel="noreferrer" data-testid="detail-whatsapp-btn">
                  <SocialIcons.WhatsApp />
                  WhatsApp
                </a>
              )}
              <button className="bd-action-btn bd-action-outline" onClick={() => setEnqOpen(true)} data-testid="detail-enquiry-btn">
                <SocialIcons.Mail />
                Send Enquiry
              </button>
              <button className="bd-action-btn bd-action-outline" onClick={share} data-testid="detail-share-btn">
                <SocialIcons.Share />
                Share card
              </button>
              {biz.website && (
                <a href={biz.website} target="_blank" rel="noreferrer" className="bd-action-btn bd-action-outline" data-testid="detail-website-btn">
                  <SocialIcons.Globe />
                  Website
                </a>
              )}
            </div>

            {socialLinks.length > 0 && (
              <div className="bd-social-row" data-testid="detail-social-links">
                <span style={{ alignSelf: 'center', fontSize: '0.78rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.08em', textTransform: 'uppercase', marginRight: '0.25rem' }}>
                  Follow
                </span>
                {socialLinks.map(({ name, href, cls, Icon, testid }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className={`bd-social-btn ${cls}`}
                    aria-label={name}
                    title={name}
                    data-testid={testid}
                  >
                    <Icon />
                  </a>
                ))}
              </div>
            )}
          </div>

          <div className="ap-card mb-3">
            <h4 className="mb-2">About</h4>
            <p className="mb-0">{biz.description || 'No description provided.'}</p>
          </div>

          {biz.gallery?.length > 0 && (
            <div className="ap-card mb-3" data-testid="detail-gallery">
              <h4 className="mb-3">Gallery</h4>
              <div className="row g-3">
                {biz.gallery.map(g => (
                  <div className="col-6 col-md-4" key={g.id}>
                    <img src={g.image_url} alt={g.caption || 'gallery'} style={{ width:'100%', height:140, objectFit:'cover', borderRadius:12 }} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {biz.products?.length > 0 && (
            <div className="ap-card mb-3" data-testid="detail-products">
              <h4 className="mb-3">Products</h4>
              <div className="row g-3">
                {biz.products.map(p => (
                  <div className="col-md-6" key={p.id}>
                    <div className="d-flex gap-3">
                      {p.image_url && <img src={p.image_url} alt={p.name} style={{ width:80, height:80, borderRadius:12, objectFit:'cover' }} />}
                      <div>
                        <div className="fw-semibold">{p.name}</div>
                        {p.price !== null && p.price !== undefined && <div className="text-muted-2 small">₹ {p.price}</div>}
                        <div className="small">{p.description}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {biz.services?.length > 0 && (
            <div className="ap-card mb-3" data-testid="detail-services">
              <h4 className="mb-3">Services</h4>
              <ul className="list-unstyled mb-0">
                {biz.services.map(s => (
                  <li key={s.id} className="d-flex justify-content-between border-bottom py-2">
                    <div>
                      <div className="fw-semibold">{s.name}</div>
                      <div className="small text-muted-2">{s.description}</div>
                    </div>
                    <div className="fw-semibold">{s.price ? `₹ ${s.price}` : '—'}</div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {(biz.latitude && biz.longitude) && (
            <div className="mb-3">
              <h4 className="mb-3">Location</h4>
              <MapEmbed latitude={biz.latitude} longitude={biz.longitude} label={biz.name} height={280} />
              <div className="small text-muted-2 mt-2">{biz.address}</div>
            </div>
          )}
        </div>

        <div className="col-lg-4">
          <div className="ap-card mb-3" data-testid="detail-card">
            <div className="d-flex align-items-center gap-3 mb-3">
              {biz.logo_url ? (
                <img src={biz.logo_url} alt={biz.name} style={{ width:56, height:56, borderRadius:12, objectFit:'cover' }} />
              ) : (
                <div style={{
                  width:56, height:56, borderRadius:12,
                  background: 'linear-gradient(135deg, #EEF2FF, #E0E7FF)',
                  color: '#4338CA', fontWeight: 800, fontSize: '1.4rem',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  {biz.name.substring(0,1).toUpperCase()}
                </div>
              )}
              <div>
                <div className="fw-bold">{biz.name}</div>
                <div className="small text-muted-2">Digital visiting card</div>
              </div>
            </div>

            {/* Contact details with icons */}
            <div className="bd-contact-item">
              <span className="bd-contact-icon"><SocialIcons.MapPin /></span>
              <div>
                <span className="bd-contact-label">Address</span>
                <div className="bd-contact-value">{biz.address || '—'}</div>
              </div>
            </div>

            <div className="bd-contact-item">
              <span className="bd-contact-icon"><SocialIcons.Phone /></span>
              <div>
                <span className="bd-contact-label">Phone</span>
                {biz.phone ? (
                  <a href={`tel:${biz.phone}`} className="bd-contact-value">{biz.phone}</a>
                ) : (
                  <div className="bd-contact-value">—</div>
                )}
              </div>
            </div>

            <div className="bd-contact-item">
              <span className="bd-contact-icon"><SocialIcons.Mail /></span>
              <div>
                <span className="bd-contact-label">Email</span>
                {biz.email ? (
                  <a href={`mailto:${biz.email}`} className="bd-contact-value">{biz.email}</a>
                ) : (
                  <div className="bd-contact-value">—</div>
                )}
              </div>
            </div>

            <div className="bd-contact-item">
              <span className="bd-contact-icon"><SocialIcons.Globe /></span>
              <div>
                <span className="bd-contact-label">Website</span>
                {biz.website ? (
                  <a href={biz.website} target="_blank" rel="noreferrer" className="bd-contact-value">{biz.website}</a>
                ) : (
                  <div className="bd-contact-value">—</div>
                )}
              </div>
            </div>

            {(biz.latitude && biz.longitude) && (
              <a className="btn-ap-outline w-100 mt-3" href={`https://maps.google.com/?q=${biz.latitude},${biz.longitude}`} target="_blank" rel="noreferrer" data-testid="detail-map-btn">
                <span className="d-inline-flex align-items-center justify-content-center gap-2">
                  <SocialIcons.MapPin style={{ width: 16, height: 16 }} />
                  Open in Maps
                </span>
              </a>
            )}

            {socialLinks.length > 0 && (
              <div className="bd-social-row">
                {socialLinks.map(({ name, href, cls, Icon, testid }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className={`bd-social-btn ${cls}`}
                    aria-label={name}
                    title={name}
                    data-testid={`${testid}-card`}
                  >
                    <Icon />
                  </a>
                ))}
              </div>
            )}
          </div>

          {biz.hours?.length > 0 && (
            <div className="ap-card" data-testid="detail-hours">
              <h5 className="mb-2">Business hours</h5>
              <ul className="list-unstyled mb-0 small">
                {biz.hours.slice().sort((a,b)=>a.day_of_week-b.day_of_week).map(h => (
                  <li key={h.id} className="d-flex justify-content-between border-bottom py-1">
                    <span>{DAYS[h.day_of_week]}</span>
                    <span>{h.is_closed ? 'Closed' : `${h.open_time?.slice(0,5)} – ${h.close_time?.slice(0,5)}`}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {enqOpen && (
        <div className="position-fixed top-0 start-0 w-100 h-100" style={{ background:'rgba(10,10,11,.55)', backdropFilter:'blur(6px)', zIndex:60 }} onClick={() => setEnqOpen(false)} data-testid="enquiry-modal">
          <div className="ap-card mx-auto mt-5" style={{ maxWidth: 480 }} onClick={(e)=>e.stopPropagation()}>
            <h4>Send enquiry</h4>
            {sent ? (
              <div>
                <p className="mb-3">Thanks! Your enquiry was sent to {biz.name}.</p>
                <button className="btn-ap" onClick={() => { setEnqOpen(false); setSent(false); setForm({ customer_name:'',customer_email:'',customer_phone:'',message:'' }); }} data-testid="enquiry-close-btn">Close</button>
              </div>
            ) : (
              <form onSubmit={submitEnq} className="mt-2" data-testid="enquiry-form">
                {enqErr && <div className="alert alert-danger py-2" data-testid="enquiry-error">{enqErr}</div>}
                <input className="form-control mb-2" placeholder="Your name" required value={form.customer_name} onChange={e=>setForm({...form, customer_name:e.target.value})} data-testid="enquiry-name" />
                <input className="form-control mb-2" placeholder="Email (optional)" value={form.customer_email} onChange={e=>setForm({...form, customer_email:e.target.value})} data-testid="enquiry-email" />
                <input className="form-control mb-2" placeholder="Phone (optional)" value={form.customer_phone} onChange={e=>setForm({...form, customer_phone:e.target.value})} data-testid="enquiry-phone" />
                <textarea className="form-control mb-2" placeholder="Message" rows={4} required value={form.message} onChange={e=>setForm({...form, message:e.target.value})} data-testid="enquiry-message" />
                <div className="d-flex gap-2">
                  <button className="btn-ap" type="submit" disabled={sending} data-testid="enquiry-submit">{sending ? '…' : 'Send'}</button>
                  <button className="btn-ap-outline" type="button" onClick={() => setEnqOpen(false)} data-testid="enquiry-cancel">Cancel</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}